import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StringUtilService {
  constructor() {}

  public static convertCamelCaseToKebabCase(text: string): string {
    return text?.replace(/([a-z])([A-Z])/g, '$1-$2')?.toLowerCase();
  }

  public static convertKebabCaseToCamelCase(text: string): string {
    return text?.replace(/-./g, (match) => match?.charAt(1)?.toUpperCase());
  }
}
